
import request from "@/utils/request";

// 前台-黑色系专题报告
export function getBlackList(params) {
  return request({
    url: '/business/report/blackList',
    method: 'get',
    params
  })
}

// 前台-化工系专题报告
export function getChemicalList(params) {
  return request({
    url: '/business/report/chemicalList',
    method: 'get',
    params
  })
}
// 黑色系查看、下载
export function getBlackReport(id) {
  return request({
    url: '/business/report/blackInfo/' + id,
    method: 'get'
  })
}

// 化工系查看、下载
export function getChemicalReport(id) {
  return request({
    url: '/business/report/chemicalInfo/' + id,
    method: 'get'
  })
}

// 获取外链分享的页面内容数
export function linkMenuTree() {
  return request({
    url: '/system/linkMenu/tree',
    method: 'get'
  })
}